import callAPiBase from './base';

const appUserMergeApi = {
  list: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/appUserMergeRequestList',
      method: 'GET',
      useToken: true,
      title: 'App User Merge - List',
      params,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/appUserMergeRequestUpdate',
      method: 'PUT',
      useToken: true,
      title: 'App User Merge - Update',
      data,
    }),
};

export default appUserMergeApi;
export { appUserMergeApi };
